import React from 'react'
import Proptypes from 'prop-types'

export const GenerateEmbedCodeForm = ({
  teamMemberEmail = '',
  teamMemberId = '',
  teamMemberFirstName = '',
  teamMemberLastName = '',
  customerEmail = '',
  customerId = '',
  customerFirstName = '',
  customerLastName = '',
  companyName = '',
  ticketId = '',
  ticketSubject = '',
  ticketGroup = '',
  handleChangePlaceHolders,
}) => (
  <React.Fragment>
    <h3>Rating placeholders</h3>
    <p>
      You can add placeholders to be included in rating URLs each time your customer responds to a
      survey.
    </p>
    <a
      href="https://help.simplesat.io/integrations/list-of-email-placeholders-for-common-helpdesks"
      target="_blank"
      rel="noreferrer"
    >
      <i className="icon far fa-book" />
      Placeholders for common helpdesks
    </a>
    <div className="ui segment">
      <form className="ui small form">
        <h4 className="ui dividing header">Team member details</h4>
        <div className="two fields">
          <div className="field">
            <label>Email address</label>
            <input
              type="email"
              name="teamMemberEmail"
              onChange={handleChangePlaceHolders}
              value={teamMemberEmail}
            />
          </div>
          <div className="field">
            <label>Team member ID</label>
            <input
              type="text"
              name="teamMemberId"
              onChange={handleChangePlaceHolders}
              value={teamMemberId}
            />
          </div>
        </div>
        <div className="two fields">
          <div className="field">
            <label>First name</label>
            <input
              type="text"
              name="teamMemberFirstName"
              onChange={handleChangePlaceHolders}
              value={teamMemberFirstName}
            />
          </div>
          <div className="field">
            <label>Last name</label>
            <input
              type="text"
              name="teamMemberLastName"
              onChange={handleChangePlaceHolders}
              value={teamMemberLastName}
            />
          </div>
        </div>
        <h4 className="ui dividing header">Customer details</h4>
        <div className="two fields">
          <div className="field">
            <label>Email address</label>
            <input
              type="email"
              name="customerEmail"
              onChange={handleChangePlaceHolders}
              value={customerEmail}
            />
          </div>
          <div className="field">
            <label>Customer ID</label>
            <input
              type="text"
              name="customerId"
              onChange={handleChangePlaceHolders}
              value={customerId}
            />
          </div>
        </div>
        <div className="two fields">
          <div className="field">
            <label>First name</label>
            <input
              type="text"
              name="customerFirstName"
              onChange={handleChangePlaceHolders}
              value={customerFirstName}
            />
          </div>
          <div className="field">
            <label>Last name</label>
            <input
              type="text"
              name="customerLastName"
              onChange={handleChangePlaceHolders}
              value={customerLastName}
            />
          </div>
        </div>
        <div className="two fields">
          <div className="field">
            <label>Company name</label>
            <input
              type="text"
              name="companyName"
              onChange={handleChangePlaceHolders}
              value={companyName}
            />
          </div>
        </div>
        <h4 className="ui dividing header">Ticket details</h4>
        <div className="two fields">
          <div className="field">
            <label>Ticket ID</label>
            <input
              type="text"
              name="ticketId"
              onChange={handleChangePlaceHolders}
              value={ticketId}
            />
          </div>
          <div className="field">
            <label>Ticket subject</label>
            <input
              type="text"
              name="ticketSubject"
              onChange={handleChangePlaceHolders}
              value={ticketSubject}
            />
          </div>
        </div>
        <div className="two fields">
          <div className="field">
            <label>Group</label>
            <input
              type="text"
              name="ticketGroup"
              onChange={handleChangePlaceHolders}
              value={ticketGroup}
            />
          </div>
        </div>
      </form>
    </div>
  </React.Fragment>
)

GenerateEmbedCodeForm.propTypes = {
  teamMemberEmail: Proptypes.string,
  teamMemberId: Proptypes.string,
  teamMemberFirstName: Proptypes.string,
  teamMemberLastName: Proptypes.string,
  customerEmail: Proptypes.string,
  customerId: Proptypes.string,
  customerFirstName: Proptypes.string,
  customerLastName: Proptypes.string,
  companyName: Proptypes.string,
  ticketId: Proptypes.string,
  ticketGroup: Proptypes.string,
  ticketSubject: Proptypes.string,
  handleChangePlaceHolders: Proptypes.func,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/GenerateEmbedCodeForm/index.js